import { SET_ERROR_MESSAGE } from './ErrorPageConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setAppError = (error) => {
  const action = {
    type: SET_ERROR_MESSAGE,
    payload: error,
  }
  return action
}
